export const getApiHost = () => (import.meta.env.VITE_API_HOST || '').replace(/\/$/, '')

export const requireApiHost = () => {
  const host = getApiHost()
  if (!host) throw new Error('api host is not configured')
  return host
}
